import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";

import Contact from "../components/Contact";


// import InnovationHub from "../components/InnovationHub";
// import ExpertiseShowcase from "../components/ExpertiseShowcase";
// import TestimonialsSection from "../components/TestimonialsSection";
// import LogoBand from "../components/FlowingBand";
// import CountUp from "../components/CountUp";
// import WorkWithUsSection from "../components/WorkWithUsSection";
// import IndustriesWeServe from "../components/IndustriesWeServe";


// import Services from "../components/Services"; // superseded by six-domain CapabilityDomains section
import CapabilityDomains from "../components/OurSolutions";
import HowWeEngage from "../components/HowWeEngage";
import Lifecycle from "../components/Lifecycle";
import StartupWorkforceHome from "../components/StartupWorkforceHome";

import BlogSection from "../components/Blogs";
import CompanyDetailsSection from "../components/CompanyDetails";


const SITE_URL = "https://chiparama.com";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 100);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <>
      <Helmet>
        <title>Chiparama | Senior-Led Semiconductor Engineering Execution</title>
        <meta
          name="description"
          content="Chiparama delivers senior-led semiconductor engineering across RTL, verification, DFT, physical design, validation and embedded systems."
        />
        <link rel="canonical" href={SITE_URL} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Chiparama | Senior-Led Semiconductor Engineering Execution" />
        <meta
          property="og:description"
          content="Chiparama delivers senior-led semiconductor engineering across RTL, verification, DFT, physical design, validation and embedded systems."
        />
        <meta property="og:url" content={SITE_URL} />
        <meta property="og:image" content={`${SITE_URL}/chiparamalogo.jpg`} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Chiparama | Senior-Led Semiconductor Engineering Execution" />
        <meta
          name="twitter:description"
          content="Chiparama delivers senior-led semiconductor engineering across RTL, verification, DFT, physical design, validation and embedded systems."
        />
        <meta name="twitter:image" content={`${SITE_URL}/chiparamalogo.jpg`} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Chiparama",
            url: SITE_URL,
            logo: `${SITE_URL}/chiparamalogo.jpg`,
            sameAs: ["https://www.linkedin.com/company/chiparama/"],
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+1-408-594-8864",
              contactType: "customer service",
              email: "contact@chiparama.com",
            },
          })}
        </script>
      </Helmet>

      <Hero />
      <CompanyDetailsSection />
      <Lifecycle />
      <CapabilityDomains />
      <HowWeEngage />
      <StartupWorkforceHome />
      {/* <LogoBand /> */}
      {/* <TestimonialsSection /> */}
      <BlogSection />


      <Contact />

    </>
  );
}
